var animated_background = '<div class="animated-background rect1"></div><div class="animated-background rect2"></div><div class="animated-background rect2"></div><div class="animated-background rect3"></div>';

function show_notification(title, type = null, destroy = true) {
  if (!title) {
    return
  }

  if (destroy) {
    iziToast.destroy();
  }

  iziToast[type]({
    title: title,
    position: 'topCenter',
    transitionIn: 'fadeIn',
    progressBar: false,
    timeout: (type == 'error' || type == 'info') ? null : 60000,
    zindex: 99999,
  });
}

function show_info(title) {
  show_notification(title, 'info');
}

function show_error(title) {
  show_notification(title, 'error');
}

function show_warning(title) {
  show_notification(title, 'warning');
}

function show_success(title) {
  show_notification(title, 'success');
}

function toast_messages_init() {
  if ($('#toast-messages').length) {
    $('#toast-messages').children().each(function (i, message) {
      show_notification(
        $(message).html(),
        $(message).data('type'),
        false
      );
    });
  }
}

function add_loading(elem) {
  if (elem) {
    elem.addClass('is-loading').removeClass('is-error');
  }
}

function remove_loading(elem) {
  if (elem) {
    elem.removeClass('is-loading').removeClass('is-error');
  }
}

function remove_loading_error(elem) {
  if (elem) {
    elem.removeClass('is-loading').addClass('is-error');
  }
}

function async_download(filename, data) {
  const blob = new Blob([data], { type: 'application/octet-stream' });
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  window.URL.revokeObjectURL(url);
}

function async_init() {
  toast_messages_init();

  $(document).on('click', '[data-async]', function (event) {
    event.preventDefault();
    let data_async = $(this).data('async');
    let [api_type, cmd_type, cmd_subtype] = data_async.split(":");
    if (typeof cmd_subtype === 'undefined') {
      cmd_subtype = null;
    }
    let fname = api_type + '_request';
    if (typeof window[fname] === 'function') {
      let data_confirm = $(this).data('confirm');
      if (data_confirm && !confirm(data_confirm)) {
        return;
      }

      var commandObject = {
        type: cmd_type,
        subtype: cmd_subtype,
      };

      // Get all the data-* attributes
      var dataAttributes = $(this).data();
      var formattedDataAttributes = {};
      $.each(dataAttributes, function (key, value) {
        var snakeCaseKey = key.replace(/([A-Z])/g, function ($1) {
          return "_" + $1.toLowerCase();
        });
        formattedDataAttributes[snakeCaseKey] = value;
      });

      if ('form' in formattedDataAttributes) {
        $.each($('#' + formattedDataAttributes['form']).serializeArray(), function () {
          formattedDataAttributes[this.name] = this.value;
        });
      }

      $.extend(commandObject, formattedDataAttributes);
      window[fname](commandObject, $(this));
    } else {
      show_error('Async type not found: ' + fname);
    }
  });
}

function async_done(ret, elem) {
  console.log('async_done called with:', ret);
  show_notification(ret.Message, ret.Level);
  if (ret.Level == 'success') {
    console.log('Success response. Url:', ret.Url);
    if (ret.Url) {
      console.log('Redirecting to:', ret.Url);
      window.location.href = ret.Url;
    } else {
      console.log('Reloading page');
      location.reload();
    }
  } else {
    console.log('Non-success level:', ret.Level);
    remove_loading(elem);
  }
}

function async_done_error(ret, elem) {
  show_error(ret.Message);
  remove_loading_error(elem);
}

function async_task_done(ret, elem) {
  if (ret.result && typeof ret.result === 'object' && ret.result.error) {
    show_error(ret.result.error);
    remove_loading(elem);
  } else {
    show_success('Task ended succesfully!');
    location.reload();
  }
}
